module.exports = "\r\n<span>{{contact.officePhone}}, {{contact.mobile}}</span>\r\n<!-- <span><br>{{contact.email}}</span> -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/detail/contact-detail/contact-detail.component.html
// module id = ./src/app/components/detail/contact-detail/contact-detail.component.html
// module chunks = main